import { Image, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowDeratizacijaKorekcijaEvdListaDefinisanihTacakaHeader: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  stanjeKorekcije: string;
  opisKorekcije: string;
}> = ({ datum, fullname, potpis, stanjeKorekcije, opisKorekcije }) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{potpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{stanjeKorekcije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{opisKorekcije}</Text>
    </View>
  </View>
);

export const TableRowDeratizacijaKorekcijaEvdListaDefinisanihTacaka: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  stanjeKorekcije: string;
  opisKorekcije: string;
}> = ({ datum, fullname, potpis, stanjeKorekcije, opisKorekcije }) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{stanjeKorekcije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{opisKorekcije}</Text>
    </View>
  </View>
);
